/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Button } from '@mui/material';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useProductSamplingInventoryContext from '../context/useProductSamplingInventoryContext';

function Table() {
  //
  const { loading, productsData, handleViewProduct, handleAddProductModal, handleDeleteProduct } =
    useContext(useProductSamplingInventoryContext);

  const columns = [
    { field: 'product_name', flex: 1, headerName: 'Product Name', width: 200 },
    { field: 'specialty', flex: 1, headerName: 'MD Specialty', width: 200 },
    { field: 'qty', flex: 1, headerName: 'Stocks', width: 200 },
    {
      field: 'action',
      flex: 1,
      headerName: 'Action',
      width: 200,
      renderCell: ({ row }) => (
        <div>
          <Button
            size='small'
            variant='contained'
            color='primary'
            onClick={(e) => handleViewProduct(row.id)}
            startIcon={<EditNoteOutlinedIcon />}
          >
            Update
          </Button>
          <Button
            size='small'
            variant='contained'
            color='error'
            sx={{ marginLeft: '10px' }}
            onClick={(e) => handleDeleteProduct(row.id)}
            startIcon={<DeleteOutlineIcon />}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Button
          size='small'
          variant='contained'
          color='success'
          sx={{ float: 'right' }}
          onClick={(e) => handleAddProductModal()}
          startIcon={<AddOutlinedIcon />}
        >
          Add New Product(S)
        </Button>
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          <DataGridPro rows={productsData} columns={columns} loading={loading} />
        </div>
      </Grid>
    </Grid>
  );
}

export default Table;
